(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("nflow"));
	else if(typeof define === 'function' && define.amd)
		define(["nflow"], factory);
	else if(typeof exports === 'object')
		exports["fusionAuthentication"] = factory(require("nflow"));
	else
		root["fusionAuthentication"] = factory(root["nflow"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/